// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import wechat from '@/plugins/wechat';
import App from './App';
import router from './router';
import store from './store';

Vue.use(wechat);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App />',
});



// WEBPACK FOOTER //
// ./src/main.js